import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Post } from 'src/app/libs/proto/forum_pb';

@Injectable({
  providedIn: 'root'
})
export class PostConversionService{

  constructor(){}

  ToStorage(req: Post) {
    const w = new BinaryWriter();
    Post.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (post: Post, errorConvert: any) => void) {
    try {
      callback( Post.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(post: Post[]) {
    const rets = new Array<Uint8Array | number[]>();

    post.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }
  FromStorages(data: any, callback: (post: Post[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Post>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Post.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }


}
